<template>
	<div>
		<common-header><div class="header-title text-left">收银台</div></common-header>
		<div class="pay-container text-left">
			<div class="tip">
				<span>订单提交成功，请尽快付款！</span>
				<span>
					订单编号：
					<span>{{ order_no }}</span>
				</span>
			</div>
			<div class="tip">
				<span>
					<span class="color-red">{{ remain.remain_time_tip }}</span>
				</span>
				<span class="color-gray">超时订单将会被取消</span>
			</div>
			<div class="pay-type">
				<p class="title">选择支付方式</p>
				<div class="flex" style="justify-content: space-around;">
					<div class="pay-item" v-for="(item,index) in payType" :key="index" :style="'order:'+(item.hot?'-1':'0')" :class="{active:chooseType == item.type}" @click="chooseType = item.type">
						<img class="pay-logo" :src="item.logo" alt="">
						<div>
							<img class="text-img" :src="item.text_img" >
							<img class="hot" v-if="item.hot" src="../../assets/pay/hot.png" alt="">
						</div>
					</div>
				</div>
			</div>
			<div class="text-right">
				<el-button type="danger" :disabled="!(chooseType&&remain.remain_time)" @click="choosePayType">立即支付</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import commonHeader from '../../components/common/commonHeader.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
	name: '',
	components: {
		commonHeader
	},
	data() {
		return {
			order_no: '',
			order: {},
			remain: {
				remain_time: '',
				remain_time_tip: ''
			},
			payType:[
				{
					type:'wxpay',
					logo:require('../../assets/pay/wxPay.png'),
					text_img:require('../../assets/pay/WePayLogo.png'),
					hot:1
				}
				,{
					type:'alipay',
					logo:require('../../assets/pay/alipay.png'),
					text_img:require('../../assets/pay/alipayLogo.png'),
					hot:0
				}
			],
			chooseType:''
		};
	},
	computed: {
		...mapState({
			loginState: state => state.user.loginState,
			userInfo: state => JSON.parse(state.user.userInfo)
		})
	},
	mounted() {
		this.order = JSON.parse(localStorage.getItem('orderpay_' + this.userInfo.id));
		this.order_no = this.order.order_no;
		this.remainTimeOne(this.order);
	},
	methods: {
		// 待付款订单倒计时
		remainTimeOne(order) {
			this.timer = setInterval(() => {
				let thistime = Math.floor(new Date().getTime() / 1000); //当前秒数
				let fukuan_time = order.ctime + 1800; //下单时间+半小时的秒数
				let remain_time = fukuan_time - thistime; //获取剩余秒数
				if (remain_time > 0) {
					this.remain.remain_time = remain_time;
					//console.log(orderList[i].remain_time);
					this.remain.remain_time_tip = '付款时间剩余：' + Math.floor(remain_time / 60) + '分' + (remain_time % 60) + '秒';
				} else {
					this.remain.remain_time = 0;
					this.remain.remain_time_tip = '订单超时已取消';
				}
			}, 1000);
		},
		choosePayType(){
			this.$router.push({'path':'/order/'+this.chooseType});
		}
	}
};
</script>
<style lang="scss">
.header-title {
	flex: 1;
	font-size: 30px;
	font-weight: bold;
	padding: 0 30px;
	line-height: 80px;
}
.pay-container {
	padding: 20px;
	.tip {
		line-height: 35px;
		span:not(:first-child) {
			margin-left: 10px;
		}
		.color-gray{
			color: gray;
		}
	}
	.pay-type{
		border: 1px solid #f3f3f3;
		padding: 15px 0;
		.title{
			font-size: 19px;
			font-weight: 600;
			line-height: 40px;
			text-align: center;
		}
		.pay-item{
			border: 1px solid #fff;
			padding: 10px;
			&:hover{
				border: 1px solid #008000;
				cursor: pointer;
			}
			&.active{
				border: 1px solid #008000;
			}
			.pay-logo{
				width: 120px;
				height: 120px;
			}
			.text-img{
				height: 40px;
				width: auto;
			}
			.hot{
				height: 20px;
				width: auto;
				vertical-align: top;
			}
		}
	}
}
</style>
